import {NgModule} from '@angular/core';
import {ExtraOptions, RouterModule, Routes} from '@angular/router';
import {AppLayoutComponent} from './layout/app.layout.component';
import {PublicLayoutComponent} from './layout/public-layout.component';
import {LoginComponent} from "./components/auth/login/login.component";
import {RegisterPersonalComponent} from "./components/auth/register-personal/register-personal.component";
import {AuthGuard} from "./guards/auth.guard";
import {RegisterDocumentComponent} from "./components/auth/register-document/register-document.component";
import {PersonalDataComponent} from "./components/auth/personal-data/personal-data.component";
import {PropertyWelcomeComponent} from "./components/property-registration/property-welcome/property-welcome.component";
import {PropertyStartComponent} from "./components/property-registration/property-start/property-start.component";
import {
    PropertySegmentsComponent
} from "./components/property-registration/property-segments/property-segments.component";
import {PropertyAddressComponent} from "./components/property-registration/property-address/property-address.component";
import {PropertyMapsComponent} from "./components/property-registration/property-maps/property-maps.component";
import {PropertyAdComponent} from "./components/property-registration/property-ad/property-ad.component";
import {PropertyListComponent} from "./components/property-list/property-list.component";
import {
    PropertyNicknameComponent
} from "./components/property-registration/property-nickname/property-nickname.component";
import {PropertySecondComponent} from "./components/property-registration/property-second/property-second.component";
import {PropertyPapersComponent} from "./components/property-registration/property-papers/property-papers.component";
import {
    PropertyDetailsPrimaryComponent
} from "./components/property-registration/property-details-primary/property-details-primary.component";
import {
    PropertyDetailsSecondaryComponent
} from "./components/property-registration/property-details-secondary/property-details-secondary.component";
import {
    PropertyPicturesComponent
} from "./components/property-registration/property-pictures/property-pictures.component";
import {
    PropertyPicturesReviewsComponent
} from "./components/property-registration/property-pictures-reviews/property-pictures-reviews.component";
import {PropertyTagsComponent} from "./components/property-registration/property-tags/property-tags.component";
import {PropertyThirdComponent} from "./components/property-registration/property-third/property-third.component";
import {PropertyPriceComponent} from "./components/property-registration/property-price/property-price.component";
import {PropertyMarketplaceComponent} from "./components/property-marketplace/property-marketplace.component";
import {PropertySuccessComponent} from "./components/property-registration/property-success/property-success.component";
import {PropertyReviewComponent} from "./components/property-registration/property-review/property-review.component";
import {PropertyListPendingComponent} from "./components/property-list-pending/property-list-pending.component";
import {PropertyDetailComponent} from "./components/property-detail/property-detail.component";

const routerOptions: ExtraOptions = {
    anchorScrolling: 'enabled'
};

const routes: Routes = [
    {
        path: '',
        component: PublicLayoutComponent,
        children: [
            { path: 'login', component: LoginComponent },
            { path: 'register', component: RegisterPersonalComponent },
            { path: '', loadChildren: () => import('./components/dashboard/dashboard.module').then(m => m.DashboardModule) },
            { path: 'register-document', component: RegisterDocumentComponent },
            { path: 'profile', component: PersonalDataComponent },
            { path: 'list-search', component: PropertyMarketplaceComponent },
        ]
    },
    {
        path: '',
        component: AppLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            { path: 'welcome', component: PropertyWelcomeComponent },
            { path: 'start', component: PropertyStartComponent },
            { path: 'segments', component: PropertySegmentsComponent },
            { path: 'nickname', component: PropertyNicknameComponent },
            { path: 'address', component: PropertyAddressComponent },
            { path: 'maps', component: PropertyMapsComponent },
            { path: 'papers', component: PropertyPapersComponent },
            { path: 'second', component: PropertySecondComponent },
            { path: 'details-primary', component: PropertyDetailsPrimaryComponent },
            { path: 'details-secondary', component: PropertyDetailsSecondaryComponent },
            { path: 'pictures', component: PropertyPicturesComponent },
            { path: 'reviews', component: PropertyPicturesReviewsComponent },
            { path: 'tags', component: PropertyTagsComponent },
            { path: 'third', component: PropertyThirdComponent },
            { path: 'ad', component: PropertyAdComponent },
            { path: 'price', component: PropertyPriceComponent },
            { path: 'review', component: PropertyReviewComponent },
            { path: 'success', component: PropertySuccessComponent },
            { path: 'list', component: PropertyListComponent },
            { path: 'list-pending', component: PropertyListPendingComponent },
            { path: 'property/:id', component: PropertyDetailComponent },
        ]
    },
    { path: 'auth', loadChildren: () => import('./demo/components/auth/auth.module').then(m => m.AuthModule) },
    { path: 'landing', loadChildren: () => import('./demo/components/landing/landing.module').then(m => m.LandingModule) },
    { path: 'notfound', loadChildren: () => import('./demo/components/notfound/notfound.module').then(m => m.NotfoundModule) },
    { path: '**', redirectTo: '/notfound' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
